export default __webpack_public_path__ + "static/media/gamesglobal.3ef49afc.png";